import { render } from "./Comments.vue?vue&type=template&id=1539a876&scoped=true&ts=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=1539a876&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1539a876"]])

export default __exports__